export default __webpack_public_path__ + "static/media/kasim_portfolio_image.0911edfe.png";